import { render, staticRenderFns } from "./chat-message-footer.vue?vue&type=template&id=76dcbb02&scoped=true&"
import script from "./chat-message-footer.vue?vue&type=script&lang=js&"
export * from "./chat-message-footer.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-footer.vue?vue&type=style&index=0&id=76dcbb02&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dcbb02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76dcbb02')) {
      api.createRecord('76dcbb02', component.options)
    } else {
      api.reload('76dcbb02', component.options)
    }
    module.hot.accept("./chat-message-footer.vue?vue&type=template&id=76dcbb02&scoped=true&", function () {
      api.rerender('76dcbb02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-message-footer/chat-message-footer.vue"
export default component.exports